import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xxl-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white" }, "Gestión de cursos", -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "svg-icon svg-icon-2" }
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = { class: "card-p mt-n20 position-relative" }
const _hoisted_7 = { class: "row m-0" }
const _hoisted_8 = { class: "col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7" }
const _hoisted_9 = { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "#/listados/cursos",
  class: "text-warning fw-bold fs-6"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-backpack",
    style: {"color":"#ffc700 !important","font-size":"24px","vertical-align":"sub"}
  }),
  /*#__PURE__*/_createTextVNode(" Cursos e inscripciones ")
], -1)
const _hoisted_11 = { class: "col bg-light-primary px-6 py-8 rounded-2 mb-7" }
const _hoisted_12 = { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "#/listados/personal",
  class: "text-primary fw-bold fs-6"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-people",
    style: {"color":"#009ef7 !important","font-size":"24px","vertical-align":"sub"}
  }),
  /*#__PURE__*/_createTextVNode(" Personal ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([`btn-active-color-${_ctx.widgetColor}`, "btn btn-sm btn-icon btn-color-white btn-active-white border-0 me-n3"]),
          "data-kt-menu-trigger": "click",
          "data-kt-menu-placement": "bottom-end",
          "data-kt-menu-flip": "top-end"
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ], 2),
        _createVNode(_component_Dropdown3)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_apexchart, {
        class: _normalizeClass([`bg-${_ctx.widgetColor}`, "mixed-widget-2-chart card-rounded-bottom"]),
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: "200",
        type: "area"
      }, null, 8, ["class", "options", "series"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
            ]),
            _hoisted_13
          ])
        ])
      ])
    ])
  ]))
}